// UserAvatar.js
import React from "react";

const UserAvatar = () => {
  return (
    <div className=" bg-accent w-10 h-10 rounded-full flex items-center justify-center shrink-0">
      <svg
        className=" fill-black"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="25"
        height="25"
      >
        <path d="M12 12c2.67 0 8 1.34 8 4v2H4v-2c0-2.66 5.33-4 8-4zm0-2a4 4 0 110-8 4 4 0 010 8z" />
      </svg>
    </div>
  );
}

export default UserAvatar